/**
 * O cupão da página de produto.
 *
 * Copia o código e diz que copiou: no botão, para quem vê, e numa região de
 * estado, para quem ouve o ecrã. Passado um bocado o botão volta ao que era,
 * para se poder copiar outra vez.
 */
const VOLTA = 2200;

class ClaroCupao extends HTMLElement {
  connectedCallback() {
    this.botao = this.querySelector('[data-claro-cupao-bt]');
    this.rotulo = this.querySelector('[data-claro-cupao-rotulo]');
    this.aviso = this.querySelector('[data-claro-cupao-aviso]');
    if (!this.botao || !this.rotulo) return;

    this.original = this.rotulo.textContent;
    this.controlo = new AbortController();
    this.botao.addEventListener('click', () => this.#copia(), { signal: this.controlo.signal });
  }

  disconnectedCallback() {
    this.controlo?.abort();
    clearTimeout(this.temporizador);
  }

  async #copia() {
    const codigo = this.dataset.codigo;
    if (!codigo) return;

    try {
      await navigator.clipboard.writeText(codigo);
    } catch {
      // Sem acesso à área de transferência: fica o código seleccionado,
      // pronto a copiar à mão.
      this.#selecciona();
      return;
    }

    const copiado = this.dataset.textoCopiado || this.original;
    this.toggleAttribute('data-feito', true);
    this.rotulo.textContent = copiado;
    if (this.aviso) this.aviso.textContent = `${codigo}: ${copiado}`;

    clearTimeout(this.temporizador);
    this.temporizador = setTimeout(() => {
      this.removeAttribute('data-feito');
      this.rotulo.textContent = this.original;
      if (this.aviso) this.aviso.textContent = '';
    }, VOLTA);
  }

  #selecciona() {
    const cod = this.querySelector('.claro-cupao__cod');
    const seleccao = getSelection();
    if (!cod || !seleccao) return;

    const intervalo = document.createRange();
    intervalo.selectNodeContents(cod);
    seleccao.removeAllRanges();
    seleccao.addRange(intervalo);
  }
}

if (!customElements.get('claro-cupao')) {
  customElements.define('claro-cupao', ClaroCupao);
}
